// ** Configs
import endPoint from 'src/configs/endpoints/pelamarEndPoints'

// ** Hook Import
import useFetch from 'src/hooks/useFetch'
import useSWR from 'swr'

// ** Type
import { PelamarIdentitasResponse } from 'src/types/pelamar-identitas'

const usePelamarIdentitas = (id?: string) => {
  // ** Hooks
  const { FetchWithPayload } = useFetch()

  const payloadPelamarIdentitas = {
    url: `${endPoint.pelamarGetAllEndpoint}/${id}`,
    method: 'GET'
  }

  const {
    data,
    isLoading: isLoadingPelamarIdentitas,
    mutate: mutatePelamarIdentitas
  } = useSWR<PelamarIdentitasResponse>(
    id ? [`${process.env.NEXT_PUBLIC_BASE_PATH}/api/reqHandler/`, payloadPelamarIdentitas] : null,
    FetchWithPayload
  )

  return {
    dataPelamarIdentitas: data && data.data,
    isLoadingPelamarIdentitas,
    mutatePelamarIdentitas
  }
}

export default usePelamarIdentitas
